import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "../lib/api";
import { BackgroundTexture } from "../components/BackgroundTexture";
import { Footer } from "../components/Footer";

export default function AboutPage() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.getSettings().then((s) => setSettings(s.data)).catch(console.error);
  }, []);

  return (
    <div data-testid="about-page" className="min-h-screen content-layer">
      <BackgroundTexture />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-8 lg:py-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <p className="text-[11px] font-medium tracking-[0.15em] text-white/60 uppercase mb-2">Our Story</p>
            <h1 className="font-syne text-3xl lg:text-4xl font-semibold text-white mb-6">About RROV</h1>
            <p className="text-white/80 leading-relaxed mb-8">
              {settings?.about_text || "RROV Goa represents the pinnacle of beach club experiences on India's western coast. A destination where world-class music meets pristine shores."}
            </p>

            <div className="panel-light p-8 rounded-md">
              <h3 className="font-syne text-lg font-semibold text-[#2D1810] mb-5">Contact</h3>
              <div className="space-y-4 text-sm">
                {settings?.address && (
                  <div className="flex items-start gap-3">
                    <MapPin size={16} className="text-[#A04D1F] mt-0.5" />
                    <span className="text-[#2D1810]/70">{settings.address}</span>
                  </div>
                )}
 
              </div>
            </div>
          </div>

          <div className="aspect-[4/5] overflow-hidden rounded-md">
            <img src="https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800" alt="RROV Goa" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
      <Footer settings={settings} />
    </div>
  );
}
